// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = ['M12 8L8 4L4 8M8 4V12'];
